import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ToastType = "coins" | "xp" | "achievement" | "levelup" | "info" | "error";

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  subtext?: string;
  amount?: number;
}

interface ToastState {
  toasts: Toast[];
}

const initialState: ToastState = { toasts: [] };

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<Omit<Toast, "id">>) => {
      state.toasts.push({
        ...action.payload,
        id: `${Date.now()}_${Math.random()}`,
      });
      // Держим не более 5 тостов
      if (state.toasts.length > 5) {
        state.toasts.shift();
      }
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
  },
});

export const { addToast, removeToast } = toastSlice.actions;
export default toastSlice.reducer;
